import React, { useState, useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import SimpleForm from 'components/SimpleForm';
import SubmitButton from 'components/SubmitButton';
import { withRouter, Link as RouterLink } from 'react-router-dom';
import { compose } from 'recompose';
import queryString from 'query-string';
import { Button } from '@material-ui/core';
import { ROUTE_LOG_IN } from 'routes/routes';
import { useFirebase } from 'components/Firebase/context';

const PasswordResetForm = ({ location }) => {
  const firebase = useFirebase();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [errorText, setErrorText] = useState(null);
  const [successText, setSuccessText] = useState(null);

  const code = queryString.parse(location.search).oobCode;
  const isInvalid = password !== passwordConfirm || password === '';

  useEffect(() => {
    if (!successText) {
      firebase
        .doVerifyPasswordResetCode(code)
        .then(email => setEmail(email))
        .catch(err => {
          setErrorText(err.message);
          setSuccessText(null);
        });
    }
  });
  const onSubmit = () => {
    firebase
      .doConfimPasswordReset(code, password)
      .then(() => {
        setSuccessText('Password reset!');
        setPassword('');
        setPasswordConfirm('');
        setErrorText(null);
      })
      .catch(err => {
        setSuccessText(null);
        setErrorText(err.message);
      });
  };

  return (
    <SimpleForm
      title="Password Reset"
      footer={
        successText && (
          //TODO: may need to put this in compoennt since its used in reset form
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="default"
            // @ts-ignore
            component={RouterLink}
            to={ROUTE_LOG_IN}
          >
            Login
          </Button>
        )
      }
      errorText={errorText}
      successText={successText}
      onSubmit={onSubmit}
    >
      <FormControl margin="normal" fullWidth>
        <InputLabel htmlFor="email">Email Address</InputLabel>
        <Input id="email" name="email" value={email} disabled autoComplete="email" />
      </FormControl>
      <FormControl margin="normal" required fullWidth>
        <InputLabel htmlFor="password">Password</InputLabel>
        <Input
          id="password"
          name="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          type="password"
          autoComplete="new-password"
        />
      </FormControl>
      <FormControl margin="normal" required fullWidth>
        <InputLabel htmlFor="re-password">Re-enter Password</InputLabel>
        <Input
          id="re-password"
          name="re-password"
          value={passwordConfirm}
          onChange={e => setPasswordConfirm(e.target.value)}
          type="password"
          autoComplete="new-password"
        />
      </FormControl>
      <SubmitButton disabled={isInvalid}>reset my password</SubmitButton>
    </SimpleForm>
  );
};

export default compose(withRouter)(PasswordResetForm);
